import React from 'react';
import { Toast } from '@fattureincloud/fic-design-system';

export const showSuccessToast = (title: string, text?: string) =>
  Toast.success(<span>{title}</span>, { content: text ? <span>{text}</span> : undefined });

export const showErrorToast = (title: string, text?: string) =>
  Toast.error(<span>{title}</span>, { content: text ? <span>{text}</span> : undefined });
